import { getOrgLeakRawApi } from "@/apis/org-api"
import { create } from "zustand"
import { langStore } from "../../../../stores/lang-store"
import { leakChartBundle } from "@/routes/apt/[apt_code]/analysis/_components/leak/leak-chart-const"

export const leakChartStore = create((set, get) => ({
  startIndex: 0,
  endIndex: 0,
  startLabel: null,
  endLabel: null,

  usageSum: 0,
  leakSum: 0,
  leakRate: 0,

  userNo: "",

  series: [],
  xLabels: [],

  setLeakChart: (usageData, leakData, xLabels) => {
    const { lang } = langStore.getState()

    const usageSeries = {
      color: "#4caefe",
      data: usageData,
      name: leakChartBundle.info.usage[lang]
    }
    const leakSeries = {
      color: "#ED561B",
      data: leakData,
      name: leakChartBundle.info.leakAmount[lang]
    }

    set({ series: [usageSeries, leakSeries], xLabels })
  },

  setRange: (start, end, labels) =>
    set({
      startIndex: start,
      endIndex: end,
      startLabel: labels?.[start] ?? null,
      endLabel: labels?.[end - 1] ?? null
    }),

  setSummary: ({ usage, leak }) =>
    set({
      usageSum: usage,
      leakSum: leak,
      leakRate: usage > 0 ? (leak / usage) * 100 : 0
    }),

  getLeakRaw: async (org, { key, start_date, end_date }) => {
    const { setLeakChart, setSummary, setRange } = get()

    let userNo = key
    if (key === null) userNo = get().userNo
    const { x_labels, datasets } = await getOrgLeakRawApi(org, { key, start_date, end_date })

    setLeakChart(datasets.usages, datasets.leaks, x_labels)

    const usage = datasets.usages.reduce((a, b) => a + b, 0)
    const leak = datasets.leaks.reduce((a, b) => a + b, 0)

    setSummary({ usage, leak })
    if (!x_labels?.length) return
    setRange(0, x_labels.length, x_labels)

    set({ userNo })
  }
}))
